<template>
  <div style="">
    <h2 style="margin: 20px">给角色授权菜单资源</h2>
    <mn-btns :btnList="roleBtns" />
    <md-scrollbar :style="{ height: $store.state.innerHeight }" class="md-btn-fixed">
      <md-tree
        :data="treeData"
        show-checkbox
        default-expand-all
        node-key="menuCode"
        ref="tree"
        highlight-current
        :props="defaultProps"
      ></md-tree>
    </md-scrollbar>
  </div>
</template>

<script>
import axios from 'axios';
import mnBtns from '../MnBtns/index.vue';


export default {
  name: 'setRole',
  components: { mnBtns },
  props: {
    row: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      //   树节点相关
      treeData: [],
      defaultProps: {
        children: 'subNodes',
        label: 'menuNameZh',
      },
      roleBtns: [
        {
          name: '提交',
          handle: this.submit,
        },
        {
          name: '取消',
          handle: () => {
            this.$emit('back');
          },
        },
      ],
    };
  },

  mounted() {
    this.queryMenuRel();
  },

  methods: {
    queryMenuRel() {
      Promise.all([
        axios.get('/gscint/menu/query'),
        axios.post('/gscint/role/queryMenuRel', {
          roleCode: this.row.roleCode,
          menuSystem: 'GSC_I',
        }),
      ]).then((res) => {
        if (res.every((k) => k.data.data.code === '1')) {
          this.treeData = res[0].data.data.datas;
          this.$nextTick(() => {
            res[1].data.data.datas.forEach(item => {
              const node = this.$refs.tree.getNode(item) || {};
              if (node.isLeaf) { // 只设置子节点，让父节点根据子节点联动
                this.$refs.tree.setChecked(node, true);
              }
            });
          });
        } else {
          this.$MdMessage.warning(res[0].data.data.msg);
        }
      });
    },
    submit() {
      const roleMenuRelList = this.$refs.tree.getCheckedNodes().map((k) => {
        return {
          baseRoleMenuId: null,
          roleCode: this.row.roleCode,
          menuCode: k.menuCode,

        };
      });
      axios
        .post('/gscint/role/saveMenuRel', {
          roleCode: this.row.roleCode,
          roleMenuRelList,
          menuSystem: 'GSC_I',
        })
        .then((res) => {
          if (res.data.data.code === '1') {
            this.$MdMessage.success('授权成功');
            this.$emit('back');
          } else {
            this.$MdMessage.warning(res.data.data.datas);
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  /deep/.head-title {
    font-size: 20px;
  }
}
</style>
